module.exports = __webpack_public_path__ + "static/media/new-arrivals.76ca472a.jpg";